import Raven from 'raven-js';

const ravenEnabled = () => !window.IS_LOCAL_INSTALL || localStorage.getItem('enableRaven');

const ignoreMessagesRegex = /(infdig)/;

if (ravenEnabled()) {
	Raven.config('https://678de0e5bc2e4027b6228f3e19dab198@sentry.io/98816', {
		autoBreadcrumbs: true,
	}).install();
}

export function errorLoggerDecorator($provide) {
	'ngInject';
	$provide.decorator('$exceptionHandler', errorLoggerExceptionHandler);
}

export function reportException(exception, user, details) {
	if (ravenEnabled()) {
		if (user) {
			Raven.setUserContext({
				name: ((user.fname_preferred || user.fname) + ' ' + (user.lname_preferred || user.lname)).trim(),
				email: user.email,
				id: user.id,
			});
		}
		Raven.captureException(exception, details);
	} else {
		console.info('Raven exception:', exception);
		if (user) {
			console.info('Raven User:', user);
		}
		if (details) {
			console.info('Raven Details:', details);
		}
	}
}

export function limitHistorySize(history) {
	const maxLength = 100000;
	const nearMax = 90000;
	if (history && JSON.stringify(history).length > maxLength) {
		// get entire first item but then just type and timestamp after that
		let first = history.slice(0, 1);
		let last = history.slice(-2);
		let middle = history.slice(1, -1).map(h => {
			const shortData = JSON.stringify(h.data).slice(0, 1024);
			return { type: h.type, data: shortData, timestamp: h.timestamp };
		});
		history = [...first, ...middle, ...last];
		if (JSON.stringify(history).length > maxLength) {
			history = JSON.stringify(history).slice(-1 * nearMax);
		}
	}
	return history;
}

export function errorLoggerExceptionHandler($delegate, $injector, $window) {
	'ngInject';
	const getUser = () => {
		let Identity = $injector.get('Identity');
		return Identity.user();
	};
	const getDetails = () => {
		let Identity = $injector.get('Identity');
		let EventTracker = $injector.get('EventTracker');
		let $location = $injector.get('$location');
		let user = Identity.user();
		let client = Identity.currentClient();
		return {
			tags: {
				deployment: $window.DEPLOYMENT,
				path: $location.path(),
				hub: client ? client.name : 'N/A',
				role: user ? user.role : 'visitor',
				page: $window.document.title.replace(/ :: .+$/, ''),
				mobile: $window.isMobile,
				app: !!$window.cordova,
				build: $window.BUILD,
				resolution: $window.screen.width + 'x' + $window.screen.height,
			},
			extra: {
				events: limitHistorySize(EventTracker.getHistory(10)),
			},
		};
	};
	return (exception, cause) => {
		try {
			if (exception.message.match(ignoreMessagesRegex)) {
				return;
			}
		} catch (e) {}
		// Use setTimeout() to let event loop finish
		// and EventTracker capture the offending click or other user action
		setTimeout(() => {
			// use try-catch in case we error trying to gather error info
			let user, details;
			try {
				user = getUser();
			} catch (e) {}
			try {
				details = getDetails();
			} catch (e) {}
			// send error to raven
			reportException(exception, user, details);
			// re-throw error to other angular delegates
			$delegate(exception, cause);
		}, 0);
	};
}
